import React from "react";
import Seo from "../components/Seo";
import Hero from "../components/Hero";
import Stats from "../components/Stats";
import ShipmentCapabilities from "../components/ShipmentCapabilities";
import WhyEasy from "../components/WhyEasy";
import Countries from "../components/Countries";
import Documentation from "../components/Documentation";
import CtaBanner from "../components/CtaBanner";
import Process from "../components/Process";
import Testimonials from "../components/Testimonials";
import Faq from "../components/Faq";

export default function Home() {
  return (
    <>
      <Seo
        title="ShipMeds | International Medicine Courier Service from India to 220+ Countries"
        description="Send all types of medicines abroad from India with ShipMeds. Free doorstep pickup, guaranteed doorstep delivery, live tracking & customs clearance across 220+ countries."
        path="/"
      />
      <Hero />
      <Stats />
      <ShipmentCapabilities />
      <WhyEasy />
      <Countries />
      <Documentation />
      <CtaBanner />
      <Process />
      <Testimonials />
      <Faq />
    </>
  );
}
